import type { ApolloError } from '@apollo/client';
import { translateBackend } from '../assets/i18n/config';

/**
 * Returns the first GraphQL error message from a caught error, preferring
 * the backend's translated `userMessage` (same cascade as the global Apollo
 * onError link in `ovApolloProvider.tsx`) and falling back to
 * `graphQLErrors[0].message`. Returns undefined when the error is not an
 * Apollo error, has no graphQLErrors, or carries no usable message.
 */
export const getGraphQLErrorMessage = (err: unknown): string | undefined => {
  const gqlError = (err as ApolloError | undefined)?.graphQLErrors?.[0];
  if (!gqlError) {
    return undefined;
  }
  const readableData = gqlError.extensions?.readableData as
    | { userMessage?: unknown }
    | undefined;
  const translated = translateBackend(readableData?.userMessage);
  return translated || gqlError.message || undefined;
};
